//  ----------      START   IMPORT  BLOCK       ----------
//  ----------  Icons
//  Professional
import img_summary from '../../Assets/Icons/SideBar/MedStaff/vitruvius_test.png'
import img_diagnosis from '../../Assets/Icons/SideBar/MedStaff/prescription-icon.png'
import img_agenda from '../../Assets/Icons/SideBar/MedStaff/calendar-icon.png'
import img_dentistry from '../../Assets/Icons/SideBar/MedStaff/tooth-icon.png'
import stethoscope from '../../Assets/Icons/SideBar/MedStaff/stethoscope-icon.png'
//  General user
import search_icon from '../../Assets/Icons/SideBar/GeneralUser/search.png'
import privacy_icon from '../../Assets/Icons/SideBar/GeneralUser/privacy.png'
import cog_icon from '../../Assets/Icons/SideBar/GeneralUser/cog.png'
import default_profile_icon from '../../Assets/Icons/SideBar/GeneralUser/default_profile.png'
import billing_icon from '../../Assets/Icons/SideBar/GeneralUser/billing.png'
import addresses_icon from '../../Assets/Icons/SideBar/GeneralUser/house.png'
import emergency_contacts_icon from '../../Assets/Icons/SideBar/GeneralUser/contacts.png'
//  Config.
import VocabSideBar from '../../ConfigFiles/multilingual/VocabSideBar';
import {ContentNames, GeneralContentNames} from '../../ConfigFiles/content_names/content_names';
//  ----------      END   IMPORT  BLOCK       ----------


export const medStaffNavLinks = [
  {
    key: ContentNames.PROFILE,
    tooltip: VocabSideBar.profile,
    img_path: stethoscope,
  },
  {
    key: ContentNames.AGENDA,
    tooltip: VocabSideBar.agenda,
    img_path: img_agenda,
  },
  {
    key: ContentNames.SUMMARY,
    tooltip: VocabSideBar.summary,
    img_path: img_summary,
  },
  {
    key: ContentNames.DIAGNOSIS,
    tooltip: VocabSideBar.diagnosis,
    img_path: img_diagnosis,
  },
  {
    key: ContentNames.DENTISTRY,
    tooltip: VocabSideBar.dentistry,
    img_path: img_dentistry,
  },
];


export const generalUserNavLinks = [
    {
      key: GeneralContentNames.SEARCH,
      tooltip: VocabSideBar.search,
      img_path: search_icon,
    },
    {
      key: GeneralContentNames.SUMMARY,
      tooltip: VocabSideBar.summary,
      img_path: default_profile_icon,
    },
      {
      key: GeneralContentNames.EMERGENCY_CONTACTS,
      tooltip: VocabSideBar.emergency_contacts,
      img_path: emergency_contacts_icon,
    },
    {
      key: GeneralContentNames.ADDRESSES,
      tooltip: VocabSideBar.addresses,
      img_path: addresses_icon,
    },
    {
      key: GeneralContentNames.PRIVACY,
      tooltip: VocabSideBar.privacy,
      img_path: privacy_icon,
    },
    /*
    //  Not ready yet
      {
      key: GeneralContentNames.BILLING,
      tooltip: VocabSideBar.billing,
      img_path: billing_icon,
    },
    */
    {
      key: GeneralContentNames.SETTINGS,
      tooltip: VocabSideBar.settings,
      img_path: cog_icon,
    },
];
